import Vue from 'vue'
import VueResource from 'vue-resource'
import mixins from '../mixins.js'
import toastr from '../toastr'
import DcForm from '../../component/dccore-form/dcForm.vue'
import RingLoader from 'vue-spinner/src/RingLoader.vue'

if ($('#brand_form').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#brand_form',
    components: {
      RingLoader,
      DcForm
    },
    mixins: [mixins],
    data: {
      brandId : null,
      loading: 0,
      form: {
        rows: [
          {
            type: 'header',
            content: {
              title: Translator.trans('form.general_information')
            }
          },
          {
            type : 'row',
            cols:[
              { type: 'text',
                content: {
                  name: 'name',
                  title: Translator.trans('brand.create.name'),
                }
              },
              {
                type : 'text',
                content: {
                  name: 'symbol',
                  title: Translator.trans('brand.create.symbol'),
                }
              },

            ],
          },
          {
            type : 'row',
            cols:[
              { type: 'text',
                content: {
                  name: 'clientAuthUrl',
                  title: Translator.trans('brand.create.client_auth_url'),
                }
              },
              { type: 'text',
                content: {
                  name: 'mailerUser',
                  title: Translator.trans('brand.create.mailer_user'),
                }
              },
            ],
          },
          {
            type : 'row',
            cols:[
              { type: 'text',
                content: {
                  name: 'clientUrl',
                  title: Translator.trans('brand.create.client_url'),
                }
              },
            ],
          },
          {
            type : 'row',
            cols:[
              {
                type : 'checkbox',
                content: {
                  name: 'isMoneyboxOldStager',
                  title: Translator.trans('brand.create.is_moneybox_rate_menu_label'),
                }
              },
              {
                type : 'checkbox',
                content: {
                  name: 'isMoneyboxRateMenu',
                  title: Translator.trans('brand.create.is_moneybox_old_stager_label'),
                }
              },
              {
                type : 'checkbox',
                content: {
                  name: 'isMoneyboxJointDelivery',
                  title: Translator.trans('brand.create.is_moneybox_joint_delivery_label'),
                }
              },
              {
                type : 'checkbox',
                content: {
                  name: 'isMoneyboxMgm',
                  title: Translator.trans('brand.create.is_moneybox_mgm_label'),
                }
              },
              {
                type : 'checkbox',
                content: {
                  name: 'isShowVariantHashtags',
                  title: Translator.trans('brand.create.is_show_variant_hashtags'),
                }
              },
              {
                type : 'checkbox',
                content: {
                  name: 'autoActiveMobileOrders',
                  title: Translator.trans('brand.create.auto_active_mobile_orders'),
                }
              }
            ],
          },
          {
            type : 'row',
            cols:[
              {
                type: 'text',
                content: {
                  name: 'moneyboxExpireMonths',
                  title: Translator.trans('brand.create.moneybox_expire_months'),
                }
              },
              {
                type: 'text',
                content: {
                  name: 'country',
                  title: Translator.trans('brand.create.country'),
                }
              },
              {
                type: 'text',
                content: {
                  name: 'currencyCode',
                  title: Translator.trans('brand.create.currencyCode'),
                }
              },
            ],
          },
        ],
        entity: {
        },
        options: {
          errors: {},
        }
      },
    },
    mounted: function () {
      if ($('#entity_id').length) {
        this.brandId = $('#entity_id').val()
        this.getBrand()
      }
    },
    watch: {
      'form.entity.country' : function() {
        this.form.entity.country = this.form.entity.country.toUpperCase()
      },
      'form.entity.currencyCode' : function() {
        this.form.entity.currencyCode = this.form.entity.currencyCode.toUpperCase()
      }
    },
    methods: {
      createBrand: function (redirect) {
        //this.buttonSave.button('loading');
        var url = Routing.generate('api_post_brand')
        Vue.http.post(url, {
          'data': this.form.entity,

        }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('brand_grid'))
          } else {
            toastr.success(Translator.trans('brand.create.created'))
          }
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      },
      updateBrand: function (redirect) {
        var url = Routing.generate('api_patch_brand', { id: this.brandId })

        Vue.http.patch(url, {
          'data': this.form.entity,
        }).then(() => {
          if (redirect) {
            $(location).attr('href', Routing.generate('brand_grid'))
          } else {
            this.form.options.errors = {}
            toastr.success(Translator.trans('brand.update.updated'))
          }
        }, response => {
          this.handleAjaxError(response, this.form.options)
        })
      },
      getBrand: function () {
        var url = Routing.generate('api_get_brand', { id: this.brandId,
          context: 'edit' })

        Vue.http.get(url).then(response => {
          this.form.entity = response.data
        }, response => {
          this.handleAjaxError(response)
        })
      },
    },
  })
}
